import { ymd } from "./format";

// v26.3 §1 — mesačná mriežka s pondelkovým predsadením (zdieľané CalendarTab + DateField picker).
// Vracia pole buniek: null = prázdne miesto pred/po mesiaci, číslo = deň v mesiaci.
export function buildMonthCells(year, month) {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const lead = (new Date(year, month, 1).getDay() + 6) % 7; // pondelok = 0
  const cells = [];
  for (let i = 0; i < lead; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}

// Map each active reminder onto the days it falls on in the given month
// (0-based). Recurring reminders repeat forward from their due date:
// 'daily' → every day, 'weekly' → same weekday every 7 days.
export function remindersForMonth(reminders, year, month) {
  const byDay = {};
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  for (const r of reminders || []) {
    if (!r.due_at) continue;
    const base = new Date(r.due_at.slice(0, 10) + "T00:00:00");
    if (isNaN(base)) continue;
    const time = r.due_at.length >= 16 ? r.due_at.slice(11, 16) : "";
    const endTime = r.end_at && r.end_at.length >= 16 ? r.end_at.slice(11, 16) : "";  // v17 §9 — event range end
    // v18 §1 — a multi-day Udalosť spans every day from due_at's date through end_at's date (cap 60d)
    const isEvent = r.plan_type === "event";
    const endBase = (isEvent && r.end_at) ? new Date(r.end_at.slice(0, 10) + "T00:00:00") : null;
    const span = (endBase && !isNaN(endBase)) ? Math.min(60, Math.round((endBase - base) / 86400000)) : 0;
    for (let d = 1; d <= daysInMonth; d++) {
      const cur = new Date(year, month, d);
      const diff = Math.round((cur - base) / 86400000);
      let show = false;
      let cTime = null;  // vlastné dátumy: čas konkrétneho dátumu (nie due_at)
      if (r.repeat === "daily") show = diff >= 0;
      else if (r.repeat === "weekly") show = diff >= 0 && diff % 7 === 0;
      // mesačne: rovnaký deň v mesiaci (koniec mesiaca priľne — 31. → posledný deň); ročne: rovnaký deň+mesiac
      else if (r.repeat === "monthly") show = diff >= 0 && d === Math.min(base.getDate(), daysInMonth);
      else if (r.repeat === "yearly") show = diff >= 0 && d === base.getDate() && month === base.getMonth();
      // vlastné dátumy: zhoda s ktorýmkoľvek z konkrétnych dátumov (nezávisle od due_at)
      else if (r.repeat === "custom") {
        const hit = (r.custom_dates || []).find((s) => s.slice(0, 10) === ymd(year, month, d));
        show = !!hit;
        if (hit && hit.length >= 16) cTime = hit.slice(11, 16);
      }
      else if (span > 0) show = diff >= 0 && diff <= span;  // multi-day event
      else show = diff === 0;
      if (show) {
        const key = ymd(year, month, d);
        // multi-day: start day shows start time, last day "do HH:MM", middle days "celý deň"
        let dTime = cTime != null ? cTime : time, dEnd = endTime;
        if (span > 0) {
          if (diff === 0) { dEnd = ""; }
          else if (diff === span) { dTime = endTime ? "do " + endTime : ""; dEnd = ""; }
          else { dTime = ""; dEnd = ""; }
        }
        (byDay[key] = byDay[key] || []).push({ ...r, time: dTime, endTime: dEnd });
      }
    }
  }
  for (const k in byDay) byDay[k].sort((a, b) => (a.time || "").localeCompare(b.time || ""));
  return byDay;
}
